import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export interface RightAsideStore {
  isHidden: boolean;
  setIsHidden: (isHidden: boolean) => void;
  toggle: () => void;
  availableCount: number;
  registerAside: () => void;
  unregisterAside: () => void;
}

export const useRightAsideStore = create<RightAsideStore>()(
  persist(
    (set) => ({
      isHidden: false,
      setIsHidden: (isHidden: boolean) => set({ isHidden }),
      toggle: () => set((state) => ({ isHidden: !state.isHidden })),
      availableCount: 0,
      registerAside: () => set((state) => ({ availableCount: state.availableCount + 1 })),
      unregisterAside: () => set((state) => ({ availableCount: Math.max(0, state.availableCount - 1) })),
    }),
    {
      name: "right-aside-state",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ isHidden: state.isHidden }),
    },
  ),
);
